var _defs, _polygon, _polygon2, _polygon3, _polyline, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNpcLyra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 706.65 706.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5c6d6d;}.cls-2{fill:#fff;opacity:.6;}.cls-3{fill:#799091;}.cls-4{fill:#8eaaad;}.cls-5{fill:aqua;}.cls-6{fill:#677a7a;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "467.64 384.84 380.15 155.8 353.36 122.91 327.14 155.8 239.07 384.56 353.36 427.74 467.64 384.84"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "253.82 584.03 449.62 584.03 474.16 549.19 231.29 549.19 253.82 584.03"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "223.18 559.98 479.06 559.98 504.28 533.54 202.38 533.54 223.18 559.98"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "352.98 427.44 467.27 384.54 379.77 155.51 352.98 122.62"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "285.98 507.71 168.91 507.18 266.34 283.32 325.93 232.97 285.98 507.71"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "420.67 507.71 537.73 507.18 440.31 283.32 380.72 232.97 420.67 507.71"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "228.45 507.3 285.11 507.3 327.14 233.28 228.45 507.3"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "478.07 507.3 421.41 507.3 379.37 233.28 478.07 507.3"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "186.94 534.4 515.28 534.4 537.41 506.61 353.36 462.82 169.24 506.61 186.94 534.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpcLyra);
export default __webpack_public_path__ + "static/media/npc-lyra.6340fb26da18ecd3cb1fdbc23870ce71.svg";
export { ForwardRef as ReactComponent };